import React from "react";

interface TabPanelProps {
    index: number;
    value: number;
    children: React.ReactNode;
    style?: React.CSSProperties | undefined;
    className?: string;
}

// Note: not using the mui TabPanel because it comes from the mui/labs package and is experimental in v5
export function AcxTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {children}
        </div>
    );
}
